import * as React from 'react';
import { mergeClasses } from '../constants';

type Props = {
  className?: string;
  size?: number;
  sort?: string | null;
};

export default class SortSpinner extends React.Component<Props> {
  render() {
    const { className, size, sort, ...rest } = this.props;
    let asc = 'in',
      desc = 'in';
    if (sort) {
      if (sort.charAt(0) === '-') {
        desc = '';
      } else {
        asc = '';
      }
    }
    return (
      <svg
        height={size || 18}
        width={size || 18}
        viewBox={'0 0 320 512'}
        style={{
          display: 'inline-block',
          fill: 'currentColor',
          lineHeight: 1,
          stroke: 'currentColor',
          strokeWidth: 0,
        }}
        {...rest}
        className={mergeClasses(['sort-spinner', className])}
        data-sort={sort}
      >
        <path
          className={`sort-${asc}active`}
          d="M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
        />
        <path
          className={`sort-${desc}active`}
          d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
        />
      </svg>
    );
  }
}
